import { ReactComponent as OrigamiSvg } from "../assets/origami.svg";
import { ReactComponent as SwordSvg } from "../assets/sword.svg";
import { TRAINING_MODE_FREE, TRAINING_MODE_QUEST } from "../constants/entrainementSetup";
import "./TrainingModeNav.css";

export default function TrainingModeNav({
  visible = false,
  mode = TRAINING_MODE_FREE,
  questSessionAvailable = false,
  onModeChange = () => {},
}) {
  if (!visible) return null;

  const isQuest = mode === TRAINING_MODE_QUEST;
  const label = isQuest ? "Session de quête" : "Entraînement libre";

  const toggleMode = () => {
    if (isQuest) {
      onModeChange(TRAINING_MODE_FREE);
      return;
    }
    if (!questSessionAvailable) return;
    onModeChange(TRAINING_MODE_QUEST);
  };

  return (
    <div className="menuFilterContainer training-mode-nav">
      <button
        type="button"
        className={`training-mode-switch${isQuest ? " is-quest" : " is-free"}`}
        role="switch"
        aria-checked={isQuest}
        aria-label={label}
        disabled={!isQuest && !questSessionAvailable}
        onClick={toggleMode}
      >
        <span className="training-mode-switch__thumb" aria-hidden="true" />

        <span className="training-mode-switch__slot training-mode-switch__slot--free" aria-hidden="true">
          <OrigamiSvg className="training-mode-switch__icon training-mode-switch__icon--origami" />
        </span>

        <span className="training-mode-switch__slot training-mode-switch__slot--quest" aria-hidden="true">
          <SwordSvg className="training-mode-switch__icon training-mode-switch__icon--sword" />
        </span>
      </button>
    </div>
  );
}
